import { FunctionComponent } from 'react'
import { Navigate, useSearchParams, createSearchParams } from 'react-router-dom'

interface IProps {
  to: string
  replace?: boolean
}

const ParamsRoute: FunctionComponent<IProps> = ({ to, replace }) => {
  const [searchParams] = useSearchParams()
  const params = Object.fromEntries([...searchParams])
  const redirectWithParams = {
    pathname: to,
    search: createSearchParams(params).toString()
  }
  const accessSource = searchParams.get('access_source')
  if (accessSource) {
    sessionStorage.setItem('access_source', accessSource)
  }

  return <Navigate to={redirectWithParams} replace={replace} />
}

export default ParamsRoute
